module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img245-c692942035da59af074d668a0face27d.jpg";